Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "eventtext2632936369",
  {"root":"eventtext2632936369--root","faded":"eventtext2632936369--faded","large":"eventtext2632936369--large"},
  "",
  2,
  "eventtext2632936369"
);

